import { Component } from 'react';
import { DOWNLOADS } from '../../../../routes';
import { prependAppPath } from '../../../services/Url';
import AlertBox from '../../AlertBox';
import Link from '../../Link';

const DELAY_WARNING_MS = 8000;

export default class Waiting extends Component {
    state = {
        isDelayed: false,
    };

    componentDidMount() {
        this.timeoutFn = setTimeout(() => {
            this.setState({
                isDelayed: true,
            });
        }, DELAY_WARNING_MS);
    }

    componentWillUnmount() {
        clearTimeout(this.timeoutFn);
    }

    render() {
        return (
            <div>
                <h1>Hang tight…</h1>
                <p>We are crunching the data for you, please wait a moment.</p>
                {this.state.isDelayed && (
                    <AlertBox colour="BLUE">
                        <span>
                            <b>This is taking longer than expected…</b> You don’t have to wait here, though. We will add
                            your export to the <Link href={prependAppPath(DOWNLOADS)}>latest exports</Link> page as soon
                            as it is finished.
                        </span>
                    </AlertBox>
                )}
            </div>
        );
    }
}
